import { api, prefix, generateQueryParamFromObj } from "@/api";
import type { AxiosRequestConfig } from "axios";
import type { notificationType } from "@/types/notification";

const namespace = "notifications";

/** Valori di `scope` accettati dalla lista. Solo "unread" e' attestato lato backend. */
export type NotificationScope = "unread" | "read";

/**
 * Lista delle notifiche: envelope `{ count, data }` (GAIA-2857). `data` e' la pagina richiesta,
 * `count` il totale delle notifiche che rispettano i filtri (scope incluso) a prescindere dalla
 * paginazione. service-gaia lo legge dall'header `x-counter` del servizio a monte: e' `null` solo
 * se quel servizio non lo manda.
 */
export interface NotificationListResponse {
  data: notificationType[];
  count: number | null;
}

export const getListNotification = (
  params: {
    scope?: NotificationScope;
    page?: number;
    limit?: number;
  },
  config: AxiosRequestConfig = {}
): Promise<NotificationListResponse> => {
  const query = generateQueryParamFromObj(params);
  // `api<T>` e' dichiarato `AxiosResponse<T>`, ma l'interceptor di `src/api` (onResponseExtractData)
  // risolve gia' il body: il valore atteso e' l'envelope, non la response axios. Stessa nota di
  // `api/apiclient/lead.ts`. Dichiararlo qui evita che ogni chiamante debba castare.
  return api<NotificationListResponse>({
    url: `${prefix}/gaia/${namespace}?${query}`,
    method: "get",
    ...config,
  }) as unknown as Promise<NotificationListResponse>;
};

export const updateNotification = (
  id: number | string,
  read: boolean,
  config: AxiosRequestConfig = {}
) =>
  api<any>({
    url: `${prefix}/gaia/${namespace}/${id}`,
    method: "put",
    data: {
      read: read,
    },
    ...config,
  });

export const markAllAsRead = (config: AxiosRequestConfig = {}) =>
  api<any>({
    url: `${prefix}/gaia/${namespace}`,
    method: "post",
    data: {},
    ...config,
  });
